import "./App.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import TrainingList from "./components/training/TrainingList";
import WeeklySummaryList from "./components/training/WeeklySummaryList";
import TrainingPeriodList from "./components/trainingPeriod/TrainingPeriodList";
import UserList from "./components/user/UserList";
import AddTraining from "./components/training/AddTraining";
import EditTraining from "./components/training/EditTraining";
import EditUser from "./components/user/EditUser";
import MainMenu from "./components/MainMenu";
import AddTrainingPeriod from "./components/trainingPeriod/AddTrainingPeriod";
import EditTrainingPeriod from "./components/trainingPeriod/EditTrainingPeriod";
import LoginScreen from "./components/LoginScreen";
import LoginModal from "./components/modals/LoginModal";

import { AppDispatch, RootState } from "./store/configureStore";
import { logoutUser } from "./actions/loginActions";

const App: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const userStore = useSelector((state: RootState) => state.loggedInUser);

  const clearDataOnLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("currentUser");
    localStorage.removeItem("userRoles");
    dispatch(logoutUser());
  };

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    let isUserLoggedIn = !!token;

    if (!userStore || !userStore.id) {
      if (isUserLoggedIn) clearDataOnLogout();
      isUserLoggedIn = false;
    }

    setIsLoggedIn(isUserLoggedIn);
    // celowo tylko raz na start (tak jak miałeś)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleShowLogin = () => setShowLoginModal(true);
  const handleCloseLogin = () => setShowLoginModal(false);

  const handleLoginSuccess = (_loginData: any) => {
    setIsLoggedIn(true);
    setShowLoginModal(false);
    navigate("/trainings");
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    clearDataOnLogout();
    navigate("/");
  };

  return (
    <div className="appRoot">
      <ToastContainer />

      <MainMenu onLogout={handleLogout} onLogin={handleShowLogin} />

      <LoginModal
        show={showLoginModal}
        onClose={handleCloseLogin}
        onLoginSuccess={handleLoginSuccess}
      />

      {/* TO JEST FIX: pełna szerokość, zero bootstrapowego max-width */}
      <main className="appContent">
        <Routes>
          <Route
            path="/"
            element={isLoggedIn ? <TrainingList /> : <LoginScreen onLoginClick={handleShowLogin} />}
          />
          <Route
            path="/trainings"
            element={isLoggedIn ? <TrainingList /> : <LoginScreen onLoginClick={handleShowLogin} />}
          />
          <Route
            path="/weekly-summary"
            element={isLoggedIn ? <WeeklySummaryList /> : <LoginScreen onLoginClick={handleShowLogin} />}
          />
          <Route
            path="/trainings/add"
            element={isLoggedIn ? <AddTraining /> : <LoginScreen onLoginClick={handleShowLogin} />}
          />
          <Route
            path="/trainings/edit/:trainingId"
            element={isLoggedIn ? <EditTraining /> : <LoginScreen onLoginClick={handleShowLogin} />}
          />
          <Route
            path="/training-periods"
            element={isLoggedIn ? <TrainingPeriodList /> : <LoginScreen onLoginClick={handleShowLogin} />}
          />
          <Route
            path="/training-periods/add"
            element={isLoggedIn ? <AddTrainingPeriod /> : <LoginScreen onLoginClick={handleShowLogin} />}
          />
          <Route
            path="/training-periods/edit/:periodId"
            element={isLoggedIn ? <EditTrainingPeriod /> : <LoginScreen onLoginClick={handleShowLogin} />}
          />
          <Route
            path="/userList"
            element={isLoggedIn ? <UserList /> : <LoginScreen onLoginClick={handleShowLogin} />}
          />
          <Route
            path="/users/edit/:userId"
            element={isLoggedIn ? <EditUser /> : <LoginScreen onLoginClick={handleShowLogin} />}
          />
          <Route
            path="/users/add"
            element={isLoggedIn ? <EditUser /> : <LoginScreen onLoginClick={handleShowLogin} />}
          />
          <Route path="/user-profile" element={<EditUser />} />
        </Routes>
      </main>
    </div>
  );
};

export default App;